import React from "react";
import { Box, Stack } from "@mui/material";
import styled from "styled-components";

const ErrorText = styled.p`
    font-size: 36px;
    font-weight: 500;
    color: ${({ theme }) => theme.palette.primary.main};
    margin: 0;
    padding: 0;
    text-transform: uppercase;
`;

const ErrorDescription = styled.p`
    font-size: 14px;
    font-weight: 300;
    margin: 0;
    padding: 0;
`;

const Error = () => {
    return (
        <Box mb={3} mx={4} pb={3}>
            <Stack alignItems="center" spacing={2}>
                <ErrorText>Error</ErrorText>
                <ErrorDescription>
                    There was a problem completing the action. Our engineers have been notified.
                    Please try again later...
                </ErrorDescription>
            </Stack>
        </Box>
    );
};

export default Error;
